import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

interface Input {
    attachmentId: string;
}

export function useRemoveProjectAttachmentMutation() {
    const queryClient = useQueryClient();
    const { project } = useProject();
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.removeProjectAttachment({
                params: {
                    projectId: project.id,
                    attachmentId: input.attachmentId,
                },
            });
            if (res.status !== 200) {
                throw new Error(`failed to remove project attachment: ${res.status}`);
            }
            await queryClient.invalidateQueries({
                queryKey: ["project", project.id, "attachments"],
            });
        },
    });
}
